import { useCallback, useState } from 'react'

const estadoInicial = {
  abierto: false,
  tipo: 'info',
  titulo: '',
  mensaje: '',
  textoAceptar: 'Aceptar',
  textoCancelar: 'Cancelar',
  mostrarCancelar: false,
  procesando: false,
  onAceptar: null,
  onCancelar: null,
}

export function useModalMensaje() {
  const [modal, setModal] = useState(estadoInicial)

  const cerrarModal = useCallback(() => {
    setModal(estadoInicial)
  }, [])

  const abrirModal = useCallback(
    (opciones) => {
      setModal({
        ...estadoInicial,
        ...opciones,
        abierto: true,
        onAceptar: opciones.onAceptar || cerrarModal,
        onCancelar: opciones.mostrarCancelar
          ? opciones.onCancelar || cerrarModal
          : opciones.onCancelar || null,
      })
    },
    [cerrarModal]
  )

  const actualizarModal = useCallback((cambios) => {
    setModal((actual) => ({ ...actual, ...cambios }))
  }, [])

  return {
    modal,
    abrirModal,
    cerrarModal,
    actualizarModal,
  }
}
